import React from 'react';
import Baumumfang from '../components/Baumumfang';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BaumumfangMondsee() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="baumumfang-mondsee-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="baumumfang-mondsee-heading">BAUMUMFANG</h1>
        </div>

        <Baumumfang ort="mondsee" />
      </div>
    </div>
  );
}

export default BaumumfangMondsee;
